import React, { useEffect, useRef } from "react";
import { FileText, Copy, ChevronLeft, Speech, Loader, WandSparkles } from "lucide-react";
import { Drawer } from "vaul";
import { can_visit, copyToHtmlClipboard, isMobileDevice } from "../../helpers";
import Skeleton from "react-loading-skeleton";

export default function AuditReportNoteViewModal(props) {
  const {
    openModal=false, 
    setOpenModal=()=>{},
    setOpacityClass = () => {},
    transcription = "",
    postVisitData = {},
    postvisitLoader = false,
    previousScrollPosition = 0,
    handleGenerateNote = () => {},
    disabledNoteGenerate = false,
    handleTranscriptChange = () => {},
    services = [],
    allKeys = [],
    activeTab = 1,
    setActiveTab = () => {}
  } = props;

  const dropdownRef = useRef(null);

  useEffect(() => {
    if(!isMobileDevice()) {
      handleDrawerClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDrawerClose = () => {
    setOpenModal(false);
    window.scrollTo(0, previousScrollPosition);
    setOpacityClass("docpro_opaciry_1");
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={openModal} onOpenChange={handleDrawerClose}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn"></Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay" />
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4">
            <Drawer.Title className="sr-only">
              Patient Audit Report Note Details
            </Drawer.Title>
            <Drawer.Description className="sr-only">
              View details of an parient audit report notes
            </Drawer.Description>
            <div className="docpro_modal_wrap docpro_style_1 docpro_modal_xl" style={{ overflow: 'unset' }}>
              <div className="docpro_modal" style={{ overflow: 'unset' }}>
                <div className="docpro_patient_body_2" style={{ height: '100%' }}>
                  <div className="docpro_patient_body_2_right" style={{ padding: 0, height: '100%', overflow: 'unset' }}>
                    <div className="docpro_modal_card_2">
                      <div className="docpro_tab_wrap">
                        <div className="docpro_tab" style={{ width: '100%' }}>
                          <button type="button"
                            className={`docpro_tab_item w-full items-center audit_report ${
                              activeTab === 1 ? "active" : ""
                            }`}
                            style={{ justifyContent: 'center' }}
                            onClick={() => { setActiveTab(1); }}
                          >
                            <FileText width={17} height={17} />
                            Note
                          </button>
                          <button type="button"
                            className={`docpro_tab_item w-full items-center audit_report ${
                              activeTab === 0 ? "active" : ""
                            }`}
                            style={{ justifyContent: 'center' }}
                            onClick={() => {setActiveTab(0);}}
                          >
                            <Speech width={17} height={17} />
                            Doctor's input
                          </button>
                        </div>
                        {activeTab === 0 && <hr />}
                      </div>
                      {activeTab === 0 && (
                        <div className="docpro_tab_modal_right" style={{ padding: '10px 0 0', height: "100%" }}>
                          <div
                            className="docpro_tab_modal_right_in relative"
                            style={{ overflow: "hidden" }}
                          >
                            <textarea
                              rows={20}
                              cols={28}
                              minLength={10}
                              id="transcription_output"
                              value={transcription}
                              onChange={handleTranscriptChange}
                              placeholder="Write what happened in the visit — symptoms, medications, exam findings, and next steps..."
                              style={{
                                width: "100%",
                                height: "calc(100% - 90px)",
                                padding: "8px",
                                outline: "none",
                                resize: "none",
                                borderRadius: "8px",
                              }}
                            />
                            <button type="button"
                              disabled={disabledNoteGenerate}
                              onClick={() => {handleGenerateNote();}}
                              className="docpro_bordered_btn size_lg width_100 docpro_fw_600 docpro_white_color docpro_upload_gradient_btn docpro_mt_auto"
                            >
                              <WandSparkles width={20} height={20} />
                              <span>Generate clinical note</span>
                              {disabledNoteGenerate && (
                                <span className="docpro_loading">
                                  <Loader width={20} height={20} />
                                </span>
                              )}
                            </button>
                          </div>
                        </div>
                      )}
                      {activeTab === 1 && (
                        <div
                          className="docpro_tab_modal_right"
                          style={{ padding: "0 0 10px 0", height: "100%" }}
                        >
                          <div className="docpro_tab_modal_right_in">
                            {postvisitLoader ? (
                              <div style={{ padding: '15px 0 35px' }}>
                                <p className="mb-1"><b>REASON FOR VISIT:</b></p>
                                <Skeleton borderRadius="8px" className="mb-2" count={2}></Skeleton>
                                <p className="mb-1"><b>HISTORY OF PRESENT ILLNESS:</b></p>
                                <Skeleton borderRadius="8px" className="mb-2" count={2}></Skeleton>
                                <Skeleton width="50%" borderRadius="8px" className="mb-2"></Skeleton>
                                <p className="mb-1"><b>REVIEW OF SYSTEMS:</b></p>
                                <Skeleton borderRadius="8px" className="mb-2"></Skeleton>
                                <Skeleton width="80%" borderRadius="8px" className="mb-2"></Skeleton>
                                <Skeleton width="60%" borderRadius="8px" className="mb-2" count={2}></Skeleton>
                                <p className="mb-1"><b>PHYSICAL EXAM:</b></p>
                                <Skeleton borderRadius="8px" className="mb-2" count={2}></Skeleton>
                                <p className="mb-1"><b>DIAGNOSIS CODE:</b></p>
                                <Skeleton width="50%" borderRadius="8px" className="mb-2" count={3}></Skeleton>
                                <p className="mb-1"><b>ASSESSMENT/PLAN:</b></p>
                                <Skeleton borderRadius="8px" className="mb-2" count={3}></Skeleton>
                                <p className="mb-1"><b>CPT CODES:</b></p>
                                <Skeleton borderRadius="8px" className="mb-2"></Skeleton>
                                <Skeleton width="60%" borderRadius="8px" className="mb-2"></Skeleton>
                                <p className="mb-1"><b>SUGGESTED SERVICES FROM PRE VISIT:</b></p>
                                <Skeleton borderRadius="8px" className="mb-2"></Skeleton>
                                <Skeleton width="60%" borderRadius="8px" className="mb-2"></Skeleton>
                                <Skeleton borderRadius="8px" className="mb-2"></Skeleton>
                                <Skeleton width="50%" borderRadius="8px" className="mb-2"></Skeleton>
                              </div>
                            ) : (
                              <div className="docpro_modal_card_1 no_style">
                                <div className="docpro_modal_card_1_body" style={{ padding: '12px 0 35px' }}>
                                  <div className="docpro_modal_card_1_content subjective_note_copy">
                                    {postVisitData && Object?.keys(postVisitData)?.length > 0 ? (
                                      <>
                                        {/* REASON FOR VISIT */}
                                        {!can_visit('ehr_veradigm') && (
                                          <>
                                            <div>
                                              <p className="chart_inline_copy">
                                                <b>REASON FOR VISIT:</b>
                                                <span className="pointer" onClick={() => copyToHtmlClipboard("reason_for_visit_copy")}>
                                                  <Copy height={14} width={14} />
                                                </span>
                                              </p>
                                              {Array.isArray(postVisitData?.reason_for_visit) &&
                                              postVisitData?.reason_for_visit?.length > 0 &&
                                              postVisitData?.reason_for_visit?.every(item => typeof item === "string") ? (
                                                <ul className="reason_for_visit_copy">
                                                  {postVisitData?.reason_for_visit.map((r, i) => (
                                                    <li key={i} className="docpro_capitalize">
                                                      {r?.replace(/^Chronic disease management:\s*/i, '')}
                                                    </li>
                                                  ))}
                                                </ul>
                                              ) : (
                                                <p className="docpro_ternary_color"><i>None</i></p>
                                              )}
                                            </div>
                                            <br />
                                          </>
                                        )}

                                        {/* HISTORY OF PRESENT ILLNESS */}
                                        <div>
                                          <p className="chart_inline_copy">
                                            <b>HISTORY OF PRESENT ILLNESS:</b>
                                            <span className="pointer" onClick={() => copyToHtmlClipboard("present_illness_copy")}>
                                              <Copy height={14} width={14} />
                                            </span>
                                          </p>
                                          <div className="present_illness_copy">
                                            {postVisitData?.history_of_present_illness ? (
                                              typeof postVisitData?.history_of_present_illness === "string" ? (
                                                <p>{postVisitData?.history_of_present_illness}</p>
                                              ) : Array?.isArray(postVisitData?.history_of_present_illness) && postVisitData?.history_of_present_illness?.length > 0 ? (
                                                postVisitData?.history_of_present_illness?.map((item, idx) => (
                                                  <span key={idx}>{item}<br /></span>
                                                ))
                                              ) : (
                                                <p className="docpro_ternary_color"><i>None</i></p>
                                              )
                                            ) : (
                                              <p className="docpro_ternary_color"><i>None</i></p>
                                            )}
                                          </div>
                                        </div>
                                        <br />

                                        {/* VITAL SIGNS */}
                                        {postVisitData?.vital_signs && Object.keys(postVisitData.vital_signs).length > 0 && (
                                          <>
                                            <div>
                                              <p className="chart_inline_copy">
                                                <b>VITAL SIGNS:</b>
                                                <span className="pointer" onClick={() => copyToHtmlClipboard("vital_signs_copy")}>
                                                  <Copy height={14} width={14} />
                                                </span>
                                              </p>
                                              <ul className="vital_signs_copy docpro_grid docpro_grid_col_3">
                                                {Object.entries(postVisitData.vital_signs)?.map(
                                                  ([signName, signValue]) => (
                                                    <li key={signName} className="docpro_grid_item">
                                                      <span>{signName}: {signValue}</span>
                                                    </li>
                                                  )
                                                )}
                                              </ul>
                                            </div>
                                            <br />
                                          </>
                                        )}

                                        {/* REVIEW OF SYSTEMS */}
                                        <div>
                                          <p className="chart_inline_copy">
                                            <b>REVIEW OF SYSTEMS:</b>
                                            <span className="pointer" onClick={() => copyToHtmlClipboard("review_of_systems_copy")}>
                                              <Copy height={14} width={14} />
                                            </span>
                                          </p>
                                          {Array?.isArray(postVisitData?.review_of_systems) && postVisitData?.review_of_systems?.length > 0 ? (
                                            <ul className="review_of_systems_copy">
                                              {postVisitData?.review_of_systems?.map((item, i) => (
                                                <li key={i}>
                                                  <span className={`mr-2 review_of_systems_copy_${i}`}>{item}</span>
                                                  <span className="pointer" onClick={() => copyToHtmlClipboard(`review_of_systems_copy_${i}`)}>
                                                    <Copy height={14} width={14} />
                                                  </span>
                                                </li>
                                              ))}
                                            </ul>
                                          ) : (
                                            <p className="docpro_ternary_color"><i>None</i></p>
                                          )}
                                        </div>
                                        <br />

                                        {/* PHYSICAL EXAM */}
                                        <div>
                                          <p className="chart_inline_copy">
                                            <b>PHYSICAL EXAM:</b>
                                            <span className="pointer" onClick={() => copyToHtmlClipboard("physical_exam_copy")}>
                                              <Copy height={14} width={14} />
                                            </span>
                                          </p>
                                          {Array?.isArray(postVisitData?.physical_exam) && postVisitData?.physical_exam?.length > 0 ? (
                                            <ul className="physical_exam_copy">
                                              {postVisitData?.physical_exam?.map((item, i) => (
                                                <li key={i}>
                                                  <span className={`mr-2 physical_exam_copy_${i}`}>{item}</span>
                                                  <span className="pointer" onClick={() => copyToHtmlClipboard(`physical_exam_copy_${i}`)}>
                                                    <Copy height={14} width={14} />
                                                  </span>
                                                </li>
                                              ))}
                                            </ul>
                                          ) : (
                                            <p className="docpro_ternary_color"><i>None</i></p>
                                          )}
                                        </div>
                                        <br />

                                        {/* DIAGNOSIS CODE */}
                                        <div>
                                          <p className="chart_inline_copy">
                                            <b>DIAGNOSIS CODE:</b>
                                          </p>
                                          {Array?.isArray(postVisitData?.icd_codes) && postVisitData?.icd_codes?.length > 0 ? (
                                            <ol style={{ margin: 0 }}>
                                              {postVisitData?.icd_codes.map((code, i) => (
                                                <li key={i}>
                                                  {code?.description} <b className="mr-2">(<span className={`diagnosis_code_copy_${i}`}>{code?.code}</span>)</b>
                                                  <span className="pointer" onClick={() => copyToHtmlClipboard(`diagnosis_code_copy_${i}`)}>
                                                    <Copy height={14} width={14} />
                                                  </span>
                                                </li>
                                              ))}
                                            </ol>
                                          ) : (
                                            <p className="docpro_ternary_color"><i>None</i></p>
                                          )}
                                        </div>
                                        <br />

                                        {/* ASSESSMENT/PLAN */}
                                        <div>
                                          <p className="chart_inline_copy">
                                            <b>ASSESSMENT/PLAN:</b>
                                          </p>
                                          {Array?.isArray(postVisitData?.assessment) && postVisitData?.assessment?.length > 0 ? (
                                            <ul>
                                              {postVisitData?.assessment?.map((item, i) => (
                                                <li key={i}>
                                                  <b className="mr-2">{item?.icd_code}</b>
                                                  <span className="pointer" onClick={() => copyToHtmlClipboard(`assessment_plan_copy_${i}`)}>
                                                    <Copy height={14} width={14} />
                                                  </span>
                                                  <br />
                                                  <span className={`assessment_plan_copy_${i}`}>{item?.assessment_plan}</span>
                                                </li>
                                              ))}
                                            </ul>
                                          ) : (
                                            <p className="docpro_ternary_color"><i>None</i></p>
                                          )}
                                        </div>
                                        <br />
                                        
                                        {/* CPT CODES */}
                                        <div>
                                          <p className="chart_inline_copy">
                                            <b>CPT CODES:</b>
                                          </p>
                                          {Array?.isArray(postVisitData?.cpt_codes) && postVisitData?.cpt_codes?.length > 0 ? (
                                            <div className="docpro_table_responsive docpro_modal_cpt_codes_table">
                                              <table
                                                className="docpro_mb_0 docpro_primary_color docpro_modal_card_1_table_2"
                                                style={{ minWidth: "350px" }}
                                              >
                                                <thead>
                                                  <tr>
                                                    <th>Service</th>
                                                    <th style={{ width: "90px" }}>Codes</th>
                                                    <th style={{ width: "40px" }}></th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {postVisitData?.cpt_codes.map((item, index) => (
                                                    <React.Fragment key={index}>
                                                      <tr>
                                                        <td>{item?.description || ""}</td>
                                                        <td className={`cpt_code_copy_${index}`}>{item?.code || ""}</td>
                                                        <td>{item?.code ? 
                                                          <span className="pointer" onClick={() => copyToHtmlClipboard(`cpt_code_copy_${index}`)}>
                                                            <Copy height={14} width={14} />
                                                          </span>
                                                        : ""}</td>
                                                      </tr>
                                                    </React.Fragment>
                                                  ))}
                                                </tbody>
                                              </table>
                                            </div>
                                          ) : (
                                            <p className="docpro_ternary_color"><i>None</i></p>
                                          )}
                                        </div>
                                        <br />

                                        {/* SUGGESTED SERVICES FROM PRE VISIT */}
                                        <div>
                                          <p className="chart_inline_copy" style={{ marginBottom: 0 }}>
                                            <b>SUGGESTED SERVICES FROM PRE VISIT:</b>
                                          </p>

                                          {services?.length > 0 ? (
                                            allKeys.length === 5 ? (
                                              services.map((item, i) => {
                                                return (
                                                  <div key={i} className="docpro_modal_suggested_card">
                                                    <div className="docpro_modal_suggested_cpt_section">
                                                      <p className="docpro_modal_suggested_cpt">
                                                        {item?.cpt_code && (
                                                          <><span className={`assessment_plan_copy_CPT${i}`}>{item?.cpt_code}</span>:{" "}</>
                                                        )}
                                                        {item?.description}
                                                      </p>
                                                      {item?.cpt_code && (
                                                        <span className="pointer" onClick={() => copyToHtmlClipboard(`assessment_plan_copy_CPT${i}`)}>
                                                          <Copy height={14} width={14} />
                                                        </span>
                                                      )}
                                                    </div>

                                                    <div className="docpro_modal_suggested_icd_assessment_section">
                                                      <div className="docpro_modal_suggested_icd_section" style={{ marginBottom: "8px" }}>
                                                        <p className="docpro_modal_suggested_icd">
                                                          {item?.icd_code && (
                                                            <><span className={`assessment_plan_copy_ICD${i}`}>{item?.icd_code}</span>{" "}—{" "}</>
                                                          )}
                                                          {item?.condition_description}
                                                        </p>
                                                        {item?.icd_code && (
                                                          <span className="pointer" onClick={() => copyToHtmlClipboard(`assessment_plan_copy_ICD${i}`)}>
                                                            <Copy height={14} width={14} />
                                                          </span>
                                                        )}
                                                      </div>

                                                      {item?.assessment_plan ? (
                                                        <div className="docpro_modal_suggested_icd_section">
                                                          <p className={`assessment_suggested_plan_copy_${i} docpro_modal_suggested_assessment_plan`}>
                                                            {item?.assessment_plan}
                                                          </p>
                                                          <span className="pointer" onClick={() => copyToHtmlClipboard(`assessment_suggested_plan_copy_${i}`)}>
                                                            <Copy height={14} width={14} />
                                                          </span>
                                                        </div>
                                                      ) : (
                                                        <p style={{ fontStyle: "italic", color: "#999" }}>No assessment plan provided.</p>
                                                      )}
                                                    </div>
                                                  </div>
                                                );
                                              })
                                            ) : (
                                              <ul>
                                                {postVisitData?.potential_services_from_previsit_plan?.map((item, i) => (
                                                  <li key={i}>
                                                    <b className="mr-2">{item?.code} {item?.description}</b>
                                                    <span className="pointer" onClick={() => copyToHtmlClipboard(`assessment_service_plan_copy_${i}`)}>
                                                      <Copy height={14} width={14} />
                                                    </span>
                                                    <br />
                                                    <span className={`assessment_service_plan_copy_${i}`}>{item?.assessment_plan}</span>
                                                  </li>
                                                ))}
                                              </ul>
                                            )
                                          ) : (
                                            <p style={{ fontStyle: "italic", color: "#999" }}>None</p>
                                          )}
                                        </div>
                                      </>
                                    ) : (
                                      <p className="docpro_ternary_color">No data available</p>
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div 
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  handleDrawerClose();
                }}
                className="docpro_back_btn docpro_fw_500 pointer"
                style={{ backgroundColor: 'transparent', minHeight: '30px', position: 'absolute', top: '2px' }}
              >
                <ChevronLeft width={22} height={22} />
                Back
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
